import { Pipe, PipeTransform } from '@angular/core';
import { I18nPluralPipe } from '@angular/common';

@Pipe({
  standalone: true,
  name: 'activityTimer'
})
export class ActivityTimerPipe implements PipeTransform {

  public dayMapping = {
    '=1': '#d ago',
    'other': '#d ago'
  }

  public hourMapping = {
    '=1': '#h ago',
    'other': '#h ago'
  }

  public minuteMapping = {
    '=1': '#m ago',
    'other': '#m ago'
  }

  public secondMapping = {
    '=1': '#s ago',
    'other': '#s ago'
  }

  constructor(private I18nPluralPipe: I18nPluralPipe) {}

  transform(value: number, index: number): string {
    if(index === 0 && value < 60) { return 'Now'; }

    const sDay = 60 * 60 * 24;
    if(value >= sDay) {
      const days = (value - value % sDay) / sDay;
      return this.I18nPluralPipe.transform(days, this.dayMapping);
    }

    const sHour = 60 * 60;
    if(value >= sHour) {
      const hours = (value - value % sHour) / sHour;
      return this.I18nPluralPipe.transform(hours, this.hourMapping);
    }

    const sMinute = 60;
    if(value >= sMinute) {
      const hours = (value - value % sMinute) / sMinute;
      return this.I18nPluralPipe.transform(hours, this.minuteMapping);
    }

    return this.I18nPluralPipe.transform(value, this.secondMapping);
  }

}
